import { render, staticRenderFns } from "./TickerAdminViewRecommendations.vue?vue&type=template&id=86d5f794&scoped=true"
import script from "./TickerAdminViewRecommendations.vue?vue&type=script&lang=js"
export * from "./TickerAdminViewRecommendations.vue?vue&type=script&lang=js"
import style0 from "./TickerAdminViewRecommendations.vue?vue&type=style&index=0&id=86d5f794&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d5f794",
  null
  
)

export default component.exports